/* Tema de la página: Claro · Medio · Oscuro (fallo de Moon, 23 oct 2026).
   - layout/theme.liquid ya puso html[data-tema] antes de pintar, leyendo localStorage («moons:tema»).
   - Aquí: clic en una opción (data-tema-opcion) o en el botón del encabezado (data-tema-ciclar, que
     va Claro → Medio → Oscuro → Claro), guardar la elección, corregir aria-pressed y el color de la
     barra del navegador (meta theme-color). Los colores viven en assets/tokens.css. */
(function () {
  var CLAVE = 'moons:tema';
  var ORDEN = ['claro', 'medio', 'oscuro'];
  var BARRA = { claro: '#FFDDDC', medio: '#FFDDDC', oscuro: '#1C1010' };
  var html = document.documentElement;

  function actual() {
    var t = html.getAttribute('data-tema');
    return ORDEN.indexOf(t) >= 0 ? t : 'claro';
  }

  function nombres(boton) {
    var lista = (boton.getAttribute('data-tema-nombres') || 'Claro|Medio|Oscuro').split('|');
    return { claro: lista[0], medio: lista[1], oscuro: lista[2] };
  }

  function pinta() {
    var tema = actual();
    document.querySelectorAll('[data-tema-opcion]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-tema-opcion') === tema ? 'true' : 'false');
    });
    document.querySelectorAll('[data-tema-ciclar]').forEach(function (b) {
      var n = nombres(b);
      var siguiente = ORDEN[(ORDEN.indexOf(tema) + 1) % ORDEN.length];
      var texto = (b.getAttribute('data-tema-texto') || 'Tema: %actual%. Cambiar a %siguiente%')
        .replace('%actual%', n[tema])
        .replace('%siguiente%', n[siguiente]);
      var lector = b.querySelector('[data-tema-lector]');
      if (lector) lector.textContent = texto;
      b.setAttribute('title', texto);
    });
  }

  function aplica(tema) {
    if (ORDEN.indexOf(tema) < 0) tema = 'claro';
    if (tema === 'claro') html.removeAttribute('data-tema');
    else html.setAttribute('data-tema', tema);
    var meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', BARRA[tema]);
    try { localStorage.setItem(CLAVE, tema); } catch (e) { /* navegación privada: el tema dura la página */ }
    pinta();
  }

  document.addEventListener('click', function (e) {
    var opcion = e.target.closest('[data-tema-opcion]');
    if (opcion) { aplica(opcion.getAttribute('data-tema-opcion')); return; }
    var ciclo = e.target.closest('[data-tema-ciclar]');
    if (ciclo) aplica(ORDEN[(ORDEN.indexOf(actual()) + 1) % ORDEN.length]);
  });

  /* Si otra pestaña cambia el tema, esta lo sigue */
  window.addEventListener('storage', function (e) {
    if (e.key === CLAVE && e.newValue && e.newValue !== actual()) aplica(e.newValue);
  });

  pinta();
  window.MoonsTema = { aplica: aplica, actual: actual };
})();
